import { createFileRoute, Link } from "@tanstack/react-router";
import { Button } from "@mui/material";
import HgBreadcrumbs from "@/common/components/ui/atoms/HgBreadcrumbs";
import AdminCriterionTopicList from "@/features/guides/components/admin/AdminCriterionTopicList";
import { useCriterionTopicsContext } from "@/pages/admin/criterion-topics";

export const Route = createFileRoute("/app/admin/criterion-topics/")({
  component: RouteComponent,
});

function RouteComponent() {
  const {
    userCanEditAllCriteria,
    userCanViewAllCriteria,
    criterionTopics,
    setCriterionTopics,
    initCriterionTopics,
    loading,
    initialDataLoaded,
  } = useCriterionTopicsContext();

  return (
    <>
      <HgBreadcrumbs
        options={[
          { title: "Admin", link: null, unlink: true },
          { title: "Criterion Topics", link: "/app/admin/criterion-topics" },
        ]}
      />
      <h1>Criterion Topic Management</h1>
      <p>
        <Button
          disabled={!userCanEditAllCriteria}
          color="primary"
          component={Link}
          to={`/app/admin/criterion-topics/new`}
          variant="contained"
          size="small"
          id="add-criterion-topic-button"
        >
          Add Criterion Topic
        </Button>
      </p>
      <AdminCriterionTopicList
        tableSize="medium"
        userCanViewAllCriteria={userCanViewAllCriteria}
        setCriterionTopics={setCriterionTopics}
        criterionTopics={criterionTopics}
        initCriterionTopics={initCriterionTopics}
        loading={loading}
        initialDataLoaded={initialDataLoaded}
      />
    </>
  );
}
